import { useEffect, useRef } from 'react';
import markGravityWebsiteHandoffReady from './gravityWebsiteHandoff/markGravityWebsiteHandoffReady.js';
import shouldCompleteSkippedGravitySignup from './shouldCompleteSkippedGravitySignup.js';

// The Clerk user.updated event for this flip triggers the deferred Gravity
// signup webhook, the same way PostSignUpHandler's finish step does. A website
// signup also needs its handoff marked ready, or the server keeps waiting on
// browser delivery of the captured website payload.
const useCompleteSkippedGravitySignup = ({ user, pathname, isSignUpComplete, hasCompanies, hasRunSignUpFinish }) => {
  const hasCompleted = useRef(false);

  useEffect(() => {
    if (hasCompleted.current || !shouldCompleteSkippedGravitySignup({ user, pathname, isSignUpComplete, hasCompanies, hasRunSignUpFinish })) {
      return;
    }

    hasCompleted.current = true;
    console.warn('[signup-bootstrap] Completing a Gravity signup that skipped the onboarding finish step.', { userId: user.id });
    user
      .update({
        unsafeMetadata: {
          ...(user.unsafeMetadata || {}),
          signupCompanyStatus: 'complete'
        }
      })
      .then(() => markGravityWebsiteHandoffReady(user.unsafeMetadata?.website_handoff_id))
      .catch((error) => {
        hasCompleted.current = false;
        console.error('[signup-bootstrap] Failed to complete a skipped Gravity signup.', { userId: user.id, message: error?.message });
      });
  }, [user, pathname, isSignUpComplete, hasCompanies, hasRunSignUpFinish]);
};

export default useCompleteSkippedGravitySignup;
